// extracted by mini-css-extract-plugin
export default {"paddingLeftRight":"Home_paddingLeftRight__jkwB5"};